<template>
  <div class="related_models_container">
    <hr>
    <h4>Informations complémentaires</h4>
    <hr>

    <div class="related_models_body_container" v-if="this.models.customer">
      <customer v-if="this.models.customer" 
        :customer="this.models.customer"
        :enable_details="false"
      >
      </customer>

      <div class="related_models_representatives_container" v-if="this.models.customer.representatives">
        <h4>Représentants légaux</h4>

        <representative  v-for="(repre, idx) in orderByMain(this.models.customer.representatives, 'representative_main')" :validation_requestable="repre" :key="'representative-' + idx">
        </representative>
      </div>

      <div class="related_models_representatives_container" v-else-if="this.models.representative">
        <h4>Représentant légal</h4>

        <representative  :validation_requestable="this.models.representative">
        </representative>
      </div>

      <div class="related_models_addresses_container" v-if="this.models.customer.hasOwnProperty('addresses')">
        <h4>Adresses</h4>

        <validation-address  v-for="(addr, idx) in orderByMainAddress(this.models.customer.addresses, 'customer_usage')" :validation_requestable="addr" :key="'address-'+idx">
        </validation-address>
      </div>

      <div class="related_models_addresses_container" v-if="this.models.hasOwnProperty('address')">
        <h4>Adresses</h4>

        <validation-address  v-for="(addr, idx) in orderByMainAddress([this.models.address], 'customer_usage')" :validation_requestable="addr" :key="'address-'+idx">
        </validation-address>
      </div>
      <!-- <div class="related_models_contract_container" v-if="this.models.hasOwnProperty('contract')">
          <contract :contract="this.models.contract">
            <div slot="contract_option" class="related_models_contract_option_container" v-if="this.models.hasOwnProperty('contract_option')">
                <contract-option :contract_option="this.models.contract_option">
                </contract-option>
            </div>
          </contract>
      </div> -->
    </div>
  </div>

</template>

<script>
import Customer from "./Details/ValidationRequestable/Customer"
import Representative from "./Details/ValidationRequestable/Representative"
import ValidationAddress from "./Details/ValidationRequestable/Address"
import Contract from "./Details/ValidationRequestable/Contract"
import ContractOption from "./Details/ValidationRequestable/Contract/Option"

export default {
  name:"RelatedModels",

  props:["models"],

  components:{
    Customer,
    Representative,
    ValidationAddress,
    Contract,
    ContractOption,
  },

  methods:{
    orderByMain(datas, field) {
      var list = []
      if (this.models.customer.main_representative)
        list.push(this.models.customer.main_representative)

      return  _.concat(list, _.orderBy(_.filter(datas, d => d.representative_main == false), d => d[field] == true, 'desc'))

    },

    orderByMainAddress(datas, field) {
      return _.orderBy(datas, d => d[field] === "main", 'desc')
    }
  },

  computed:{

  }
}
</script>

<style scoped>
.related_models_representatives_container{
  padding: 0 15px;
  width: 100%;
  background-color: white;
}

.related_models_addresses_container{
  padding: 0 15px;
  width: 100%;
  background-color: white;
}

.related_models_representatives_container > div, 
.related_models_addresses_container > div { 
  margin-bottom: 15px; 
}

.related_models_body_container {
  display: flex;
  flex-direction: row;
}

.related_models_container {
    margin-top: 15px;
    margin-bottom: 15px;
}

.related_models_container > hr { width: 20%; border-width: 5px; margin-top: 30px; }
.related_models_container > h4 { text-align: center; margin-bottom: 20px; }

.customer_and_representative_container {
}

.related_models_contract_container {
  width: 100%;
  border:solid 1px lightgray;
  padding: 0 15px;
  background: white;
}

@media screen and (max-width: 800px) {

  .related_models_representatives_container {
    width: 100%;
    display: block;
    margin: 0;
    margin-bottom: 15px;
  }

  .related_models_contract_container {
    width: 100%;
    display: block;
    margin: 0;
    margin-bottom: 15px;
  }

  .related_models_addresses_container {
    width: 100%;
    display: block;
    margin: 0;
    margin-bottom: 15px;
  }

  .centered {
    align-content: none;
    display:inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/RelatedModels.vue